import React from "react";
import { cn } from "@/lib/utils";

export function HeroBackground({ image, overlay = "default", className }) {
  const overlayClass = overlay === "light"
    ? "from-ocean/60 via-atlantic/45 to-primary/35"
    : overlay === "dark"
      ? "from-ocean/85 via-atlantic/70 to-primary/50"
      : "from-ocean/75 via-atlantic/60 to-primary/45";

  return (
    <>
      {image && (
        <img
          src={image}
          alt=""
          loading="eager"
          decoding="async"
          fetchpriority="high"
          className="absolute inset-0 h-full w-full object-cover"
          aria-hidden="true"
        />
      )}
      <div className={cn("absolute inset-0 bg-gradient-to-br", overlayClass, className)} aria-hidden="true" />
      <div className="absolute inset-0 maritime-wave-pattern opacity-35" aria-hidden="true" />
    </>
  );
}

export function HeroContent({ eyebrow, title, subtitle, actions, children, className, align = "left" }) {
  return (
    <div className={cn("hero-content-stack", align === "center" && "mx-auto text-center items-center", className)}>
      {eyebrow}
      <div className="space-y-[var(--hero-title-gap)]">
        <h1 className="hero-title">{title}</h1>
        {subtitle && <p className="hero-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className={cn("hero-actions", align === "center" && "justify-center")}>{actions}</div>}
      {children}
    </div>
  );
}

export default function HeroLayout({
  eyebrow,
  title,
  subtitle,
  actions,
  aside,
  children,
  backgroundImage,
  overlay = "default",
  align = "left",
  className,
  contentClassName,
  backgroundClassName,
}) {
  return (
    <section className={cn("maritime-standard-hero", className)}>
      <HeroBackground image={backgroundImage} overlay={overlay} className={backgroundClassName} />
      <div className={cn("hero-inner", aside && "hero-inner-with-aside")}>
        <HeroContent eyebrow={eyebrow} title={title} subtitle={subtitle} actions={actions} align={align} className={contentClassName}>
          {children}
        </HeroContent>
        {aside && <div className="hero-aside">{aside}</div>}
      </div>
    </section>
  );
}